export const cssInAppSelectors = {
  BANNER: `
    .inapp-banner-layout {
      display: flex;
      background-color: #fff;
      max-height: 65px;
      border-radius: 8px;
      box-shadow: rgb(206, 206, 206) 0px 0px 6px -1px;
      overflow: hidden;
      z-index: 9999;
      padding: 10px;
      margin-inline: auto;
      gap: 12px;
      width: calc(100% - 48px);
    }

    .inapp-banner-texts-box {
      display: flex;
      gap: 2px;
      flex-direction: column;
      text-align: start;
      padding-inline: 10px;
    }

    .inapp-img-container {
      width: 100%;
      background-color: #f2f2f2;
      max-width: 68px;
      overflow: hidden;
      border-radius: 4px;
    }

    .inapp-message-title {
      font-size: 14px;
      font-weight: bold;
      text-overflow: ellipsis;
      max-width: 100%;
    }

    .inapp-message-body {
      font-size: 12px;
      text-overflow: ellipsis;
      max-width: 100%;
    }

    .inapp-banner-layout img {
      object-fit: cover;
      object-position: center;
      pointer-events: none;
    }
  `,
  BANNER_RTL: `.inapp-banner-rtl-layout {
  display: flex;
  background-color: #fff;
  max-height: 65px;
  border-radius: 8px;
  box-shadow: rgb(206, 206, 206) 0px 0px 6px -1px;
  overflow: hidden;
  z-index: 9999;
  padding: 10px;
  justify-content: flex-end;
  margin-inline: auto;
  gap: 12px;
  width: calc(100% - 48px);
}

.inapp-banner-texts-box {
  display: flex;
  gap: 2px;
  flex-direction: column;
  padding-inline: 10px;
  text-align: end;
}

.inapp-img-container {
  width: 100%;
  background-color: #f2f2f2;
  max-width: 68px;
  overflow: hidden;
  border-radius: 4px;
}

.inapp-message-title {
  font-size: 14px;
  font-weight: bold;
  text-overflow: ellipsis;
  max-width: 100%;
}

.inapp-message-body {
  font-size: 12px;
  text-overflow: ellipsis;
  max-width: 100%;
}

.inapp-banner-layout img {
  object-fit: cover;
  object-position: center;
  pointer-events: none;
}

`,
  CARD: `
    .inapp-banner-layout {
      display: flex;
      background-color: #fff;
      max-height: 65px;
      border-radius: 8px;
      box-shadow: rgb(206, 206, 206) 0px 0px 6px -1px;
      overflow: hidden;
      z-index: 9999;
      padding: 10px;
      margin-inline: auto;
      gap: 12px;
      width: calc(100% - 48px);
    }

    .inapp-banner-texts-box {
      display: flex;
      gap: 2px;
      flex-direction: column;
      text-align: start;
      padding-inline: 10px;
    }

    .inapp-img-container {
      width: 100%;
      background-color: #f2f2f2;
      max-width: 68px;
      overflow: hidden;
      border-radius: 4px;
    }

    .inapp-message-title {
      font-size: 14px;
      font-weight: bold;
      text-overflow: ellipsis;
      max-width: 100%;
    }

    .inapp-message-body {
      font-size: 12px;
      text-overflow: ellipsis;
      max-width: 100%;
    }

    .inapp-banner-layout img {
      object-fit: cover;
      object-position: center;
      pointer-events: none;
    }
  `,
  COUPON: `

  .inapp-coupon-layout {
  display: flex;
  border-radius: 8px;
  text-align: center;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f2f2f2;
  box-shadow: rgb(206, 206, 206) 0px 0px 6px -1px;
  overflow: hidden;
  z-index: 9999;
  margin-inline: auto;
  gap: 16px;
  min-height: 140px;
  width: calc(100% - 32px);
}

.inapp-coupon-texts-box {
  display: flex;
  gap: 4px;
  flex-direction: column;
  padding-inline: 10px;
}

.inapp-message-title {
  font-size: 14px;
  font-weight: bold;
  text-overflow: ellipsis;
  max-width: 100%;
}

.inapp-message-body {
  font-size: 12px;
  text-overflow: ellipsis;
  max-width: 100%;
}

.inapp-coupon-layout img {
  border-radius: 8px;
  inset: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  position: absolute;
  object-fit: cover;
  object-position: center;
  pointer-events: none;
}

.inapp-coupon-layout input {
  border-radius: 4px;
  width: 100%;
  max-width: 250px;
  height: 30px;
  border: #f2f2f2;
  outline: none;
  padding-inline: 8px;
}
`,
  IMAGE_ONLY: `
  .inapp-image-layout {
  display: flex;
  border-radius: 8px;
  text-align: center;
  flex-direction: column;
  align-items: center;
  background-color: #f2f2f2;
  box-shadow: rgb(206, 206, 206) 0px 0px 6px -1px;
  overflow: hidden;
  z-index: 9999;
  margin-inline: auto;
  max-height: 190px;
  width: calc(100% - 48px);
}

.inapp-image-layout img {
  border-radius: 8px;
  object-fit: cover;
  object-position: center;
  pointer-events: none;
}

  `,
  MODAL: `
  .inapp-modal-layout {
  display: flex;
  background-color: #fff;
  border-radius: 8px;
  padding: 10px;
  text-align: center;
  flex-direction: column;
  align-items: center;
  box-shadow: rgb(206, 206, 206) 0px 0px 6px -1px;
  overflow: hidden;
  z-index: 9999;
  margin-inline: auto;
  gap: 12px;
  width: calc(100% - 48px);
}

.inapp-img-container {
  width: 100%;
  max-height: 190px;
  background-color: #f2f2f2;
  overflow: hidden;
  border-radius: 8px;
}

.inapp-message-title {
  font-size: 14px;
  font-weight: bold;
  text-overflow: ellipsis;
  max-width: 100%;
}

.inapp-message-body {
  font-size: 12px;
  text-overflow: ellipsis;
  max-width: 100%;
}

.inapp-modal-layout img {
  border-radius: 8px;
  object-fit: cover;
  object-position: center;
  pointer-events: none;
}

.inapp-modal-layout button {
  border: none;
  outline: none;
  background-color: #000;
  color: #fff;
  width: fit-content;
  max-width: 100%;
  padding: 4px 16px;
  border-radius: 4px;
  cursor: pointer;
}
`,
};

export const cssOnSiteSelectors = {
  COUPON: `.onsite-coupon-layout {
  display: flex;
  border-radius: 8px;
  text-align: center;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f2f2f2;
  box-shadow: rgb(206, 206, 206) 0px 0px 6px -1px;
  overflow: hidden;
  z-index: 9999;
  margin-inline: auto;
  gap: 16px;
  min-height: 140px;
  width: calc(100% - 32px);
}

.onsite-coupon-texts-box {
  display: flex;
  gap: 4px;
  flex-direction: column;
  padding-inline: 10px;
}

.onsite-message-title {
  font-size: 14px;
  font-weight: bold;
  text-overflow: ellipsis;
  max-width: 100%;
}

.onsite-message-body {
  font-size: 12px;
  text-overflow: ellipsis;
  max-width: 100%;
}

.onsite-coupon-layout img {
  border-radius: 8px;
  inset: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  position: absolute;
  object-fit: cover;
  object-position: center;
  pointer-events: none;
}

.onsite-coupon-layout input {
  border-radius: 4px;
  width: 100%;
  max-width: 250px;
  height: 30px;
  border: #f2f2f2;
  outline: none;
  padding-inline: 8px;
}
`,
  IMAGE: `.onsite-image-layout {
  display: flex;
  border-radius: 8px;
  text-align: center;
  flex-direction: column;
  align-items: center;
  background-color: #f2f2f2;
  box-shadow: rgb(206, 206, 206) 0px 0px 6px -1px;
  overflow: hidden;
  z-index: 9999;
  margin-inline: auto;
  max-height: 190px;
  width: calc(100% - 48px);
}

.onsite-image-layout img {
  border-radius: 8px;
  object-fit: cover;
  object-position: center;
  pointer-events: none;
}
`,
  TEXT: `.onsite-text-layout {
  display: flex;
  background-color: #fff;
  border-radius: 8px;
  padding: 0;
  text-align: center;
  flex-direction: column;
  align-items: center;
  box-shadow: rgb(206, 206, 206) 0px 0px 6px -1px;
  overflow: hidden;
  z-index: 9999;
  margin-inline: auto;
  gap: 12px;
  width: calc(100% - 48px);
}

.onsite-img-container {
  width: 100%;
  max-height: 190px;
  background-color: #f2f2f2;
  overflow: hidden;
  border-radius: 8px;
}

.onsite-message-title {
  font-size: 14px;
  font-weight: bold;
  text-overflow: ellipsis;
  max-width: 100%;
}

.onsite-message-body {
  font-size: 12px;
  text-overflow: ellipsis;
  max-width: 100%;
}

.onsite-modal-layout img {
  border-radius: 8px;
  object-fit: cover;
  object-position: center;
  pointer-events: none;
}

.onsite-modal-layout button {
  border: none;
  outline: none;
  background-color: #000;
  color: #fff;
  width: fit-content;
  max-width: 100%;
  padding: 4px 16px;
  border-radius: 4px;
  cursor: pointer;
}
`,
};
